import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { IconButton } from '../Button/IconButton/IconButton';
import CheckCircleIcon from '../Icons/solid/CheckCircleIcon';
import ExclamationTriangleIcon from '../Icons/solid/ExclamationTriangleIcon';
import InformationCircleIcon from '../Icons/solid/InformationCircleIcon';
import XCircleIcon from '../Icons/solid/XCircleIcon';
import XMarkIcon from '../Icons/solid/XMarkIcon';
import Spinner from '../Spinner';
import { cn } from '../utils/classes';
const icons = {
  primary: <InformationCircleIcon className="h-5 w-5 text-indigo-400" aria-hidden="true" />,
  secondary: <InformationCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />,
  success: <CheckCircleIcon className="h-5 w-5 text-icon-success-subtle" aria-hidden="true" />,
  warning: <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />,
  danger: <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
};
export const Toast = t0 => {
  const $ = _c(31);
  const {
    message,
    color,
    onClose,
    Actions,
    alignContent: t1,
    toast,
    hasIcon: t2,
    customIcon,
    loading: t3
  } = t0;
  const alignContent = t1 === undefined ? "center" : t1;
  const hasIcon = t2 === undefined ? true : t2;
  const loading = t3 === undefined ? false : t3;
  const icon = customIcon ?? icons[color];
  const t4 = toast.visible ? "animate-toast-enter" : "animate-toast-leave";
  let t5;
  if ($[0] !== t4) {
    t5 = cn("bg-surface-inverse border-0 text-sm leading-5 font-normal text-white rounded-lg shadow-lg p-3 max-w-[368px] w-full", t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = alignContent === "center";
  const t7 = alignContent === "start";
  let t8;
  if ($[2] !== t6 || $[3] !== t7) {
    t8 = cn("flex gap-3", {
      "items-center": t6,
      "items-start": t7
    });
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== hasIcon || $[6] !== icon || $[7] !== loading) {
    t9 = loading ? <Spinner size="sm" /> : hasIcon && <div className="shrink-0">{icon}</div>;
    $[5] = hasIcon;
    $[6] = icon;
    $[7] = loading;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = alignContent === "center";
  const t11 = alignContent === "start";
  let t12;
  if ($[9] !== t10 || $[10] !== t11) {
    t12 = cn("min-w-0 flex flex-1 flex-wrap justify-between gap-3", {
      "items-center": t10,
      "items-start": t11
    });
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== message) {
    t13 = <span className="flex-1 min-w-0 break-words">{message}</span>;
    $[12] = message;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== Actions) {
    t14 = Actions && <div className="w-full">{Actions}</div>;
    $[14] = Actions;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t12 || $[17] !== t13 || $[18] !== t14) {
    t15 = <div className={t12}>{t13}{t14}</div>;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== onClose) {
    t16 = onClose && <div className="flex shrink-0"><IconButton aria-label="close toast" type="button" size="xxs" color="white" variant="text" icon={XMarkIcon} onClick={onClose} /></div>;
    $[20] = onClose;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t15 || $[23] !== t16 || $[24] !== t8 || $[25] !== t9) {
    t17 = <div className={t8}>{t9}{t15}{t16}</div>;
    $[22] = t15;
    $[23] = t16;
    $[24] = t8;
    $[25] = t9;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== color || $[28] !== t17 || $[29] !== t5) {
    t18 = <div className={t5} role="status" data-status={color}>{t17}</div>;
    $[27] = color;
    $[28] = t17;
    $[29] = t5;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};